<template>
  <DialogSelectTable v-bind="$props" v-on="$listeners">
    <template #btn v-if="textBtn">
      <el-button
        type="text"
        size="mini"
        icon="el-icon-plus"
        style="margin-left: 6px"
        @click="gotoRouter"
      >
        {{ textBtn }}
      </el-button>
    </template>
  </DialogSelectTable>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

<script setup>
import { useRouter } from 'vue-router/composables'
import DialogSelectTable from './dialog-select-table.vue'

const props = defineProps({
  width: {
    type: String,
    default: '740px',
  },
  columnTableCode: String,
  url: String,
  method: {
    type: String,
    default: 'post',
  },
  paramater: Object,
  keywordKey: {
    type: String,
    default: 'parameters.keyword',
  },
  //选中项是否是对象
  valueIsObj: {
    type: Boolean,
    default: true,
  },
  //每页获取数据条数，为0或不存在时表示不使用分页查询
  pageSize: {
    type: Number,
    default: 20,
  },
  value: [String, Object],
  //选中项的唯一值，当valueIsObj为true时直接返回查询接口返回的结构，否则返回查询接口返回的selectionKey对应的值
  selectionKey: {
    type: String,
    default: 'id',
  },
  //接口返回数据的唯一值，默认和selectionKey一样, 当多选或valueIsObj===faluse的时候必须和selectionKey一样
  requestDataKey: String,
  showName: {
    type: String,
    default: 'name',
  },
  showCode: {
    type: String,
    default: 'code',
  },
  disabled: Boolean,
  placeholder: {
    type: String,
    default: '编码/名称',
  },
  textBtn: {
    type: String,
    default: '',
  },
  gotoName: {
    type: String,
    default: '',
  },
  gotoQuery: {
    type: Object,
    default: () => ({}),
  },
})

const router = useRouter()

const gotoRouter = () => {
  if (props.gotoName) {
    let query = Object.assign({}, props.gotoQuery)
    router.push({ name: props.gotoName, query: query })
  }
}
</script>
